import { Typography } from '@mui/material';
import { bagStatuses } from '@/constants/Bag';

export const WeightField = record => {
    if (!record) return null;

    const formatNumber = num => {
        if (num === null || num === undefined || num === '') return '0';
        return Number(num)
            .toLocaleString('pl-PL', {
                useGrouping: true,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            })
            .replace(/,/g, ' ');
    };

    const weight = formatNumber(record.weight);
    const weightText = `${weight} g`;

    return (
        <Typography variant='body2' className={record.status === bagStatuses.in_progress ? 'gray' : ''}>
            {weightText}
        </Typography>
    );
};
